import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetInformationUsers = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_USERS_INFORMATION
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetInformationUsersAction(data.data.count));
                dispatch(Action.SetGetInformationSpinAction(data.countBet));
                dispatch(Action.SetGetDetalizationSpinAction(data.detalizationBet));
                dispatch(Action.SetGetNewUsersAction(data.usersNew.count));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetInformationUsers as SetGetInformationUsers
}